<template>
    <div class="tickIcon" @click="tickClicked">
        <input type="checkbox" id="check" checked>
        <label for="check">
            <div class="check-icon"></div>
        </label>
    </div>
</template>

<script>
export default {
  methods: {
    tickClicked() {
      this.$emit('perform-tick-click-action', null)
    }
  }
}
</script>

<style lang="css" scoped>

.tickIcon {
  margin-top: -20px;
}

label{
  position: relative;
  height: 125px;
  width: 125px;
  display: inline-block;
  border: 4px solid rgba(255,255,255,0.2);
  border-radius: 50%;
  border-left-color: var(--primary);
  animation: rotate 1.2s linear infinite;
}
@keyframes rotate {
  50%{
    border-left-color: #e6b222;
  }
  75%{
    border-left-color: #e67e22;
  }
  100%{
    transform: rotate(360deg);
  }
}
label .check-icon{
  display: none;
}
label .check-icon:after{
  position: absolute;
  content: "";
  top: 50%;
  left: 28px;
  transform: scaleX(-1) rotate(135deg);
  height: 56px;
  width: 28px;
  border-top: 7px solid var(--primary);
  border-right: 7px solid var(--primary);
  transform-origin: left top;
  animation: check-icon 0.8s ease;
}
@keyframes check-icon {
  0%{
    height: 0;
    width: 0;
    opacity: 1;
  }
  20%{
    height: 0;
    width: 28px;
    opacity: 1;
  }
  40%{
    height: 56px;
    width: 28px;
    opacity: 1;
  }
  100%{
    height: 56px;
    width: 28px;
    opacity: 1;
  }
}
input{
  display: none; 
}
input:checked ~ label .check-icon{
  display: block;
}
input:checked ~ label{
  animation: none;
  border-color: var(--primary);
  transition: border 0.5s ease-out;
}

</style>